export default __webpack_public_path__ + "static/media/isabella-nunes-modal.64eb7876.jpg";